import React from 'react';
import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import Iconify from 'src/components/iconify';
// import PersonIcon from '@mui/icons-material/Person';
// import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
// import SearchIcon from '@mui/icons-material/Search';

const ViewSwitcher = ({ 
  activeView, 
  onViewChange, 
  userId, 
  roomId, 
  onUserIdChange, 
  onRoomIdChange,
  onSubmit,
  isLoading 
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <Box
      sx={{
        width: 280,
        borderRadius: '20px',
        background: 'rgba(20, 10, 50, 0.6)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        overflow: 'hidden',
      }}
    >
      {/* View Toggle */}
      <Box
        sx={{
          display: 'flex',
          p: 0.5,
          m: 2,
          mb: 2,
          borderRadius: '12px',
          background: 'rgba(255, 255, 255, 0.05)',
        }}
      >
        <Box
          onClick={() => onViewChange('user')}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            py: 1,
            px: 1.5,
            borderRadius: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            background: activeView === 'user' 
              ? 'linear-gradient(135deg, #00f5ff20, #b24cff20)' 
              : 'transparent',
            border: activeView === 'user'
              ? '1px solid rgba(0, 245, 255, 0.3)'
              : '1px solid transparent',
            '&:hover': {
              background: activeView === 'user' 
                ? 'linear-gradient(135deg, #00f5ff20, #b24cff20)'
                : 'rgba(255, 255, 255, 0.05)',
            },
          }}
        >
          {/* <PersonIcon 
            sx={{ 
              fontSize: 18, 
              color: activeView === 'user' ? '#00f5ff' : 'rgba(255,255,255,0.5)',
            }} 
          /> */}
          <Iconify
            icon="ic:baseline-person"
            width={18}
            style={{
              color: activeView === 'user' ? '#00f5ff' : 'rgba(255,255,255,0.5)',
            }}
          />

          <Typography 
            sx={{ 
              fontSize: '0.8rem', 
              fontWeight: 500,
              color: activeView === 'user' ? '#fff' : 'rgba(255,255,255,0.5)',
            }}
          >
            User
          </Typography>
        </Box>
        
        <Box
          onClick={() => onViewChange('room')}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            py: 1,
            px: 1.5,
            borderRadius: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            background: activeView === 'room' 
              ? 'linear-gradient(135deg, #4d6cff20, #ff3cac20)' 
              : 'transparent',
            border: activeView === 'room'
              ? '1px solid rgba(77, 108, 255, 0.3)'
              : '1px solid transparent',
            '&:hover': {
              background: activeView === 'room' 
                ? 'linear-gradient(135deg, #4d6cff20, #ff3cac20)'
                : 'rgba(255, 255, 255, 0.05)',
            },
          }}
        >
          {/* <MeetingRoomIcon 
            sx={{ 
              fontSize: 18, 
              color: activeView === 'room' ? '#4d6cff' : 'rgba(255,255,255,0.5)',
            }} 
          /> */}
          <Iconify
            icon="ic:baseline-meeting-room"
            width={18}
            style={{
              color: activeView === 'room' ? '#4d6cff' : 'rgba(255,255,255,0.5)',
            }}
            />

          <Typography 
            sx={{ 
              fontSize: '0.8rem', 
              fontWeight: 500,
              color: activeView === 'room' ? '#fff' : 'rgba(255,255,255,0.5)',
            }}
          >
            Room
          </Typography>
        </Box>
      </Box>

      {/* Input Field */}
      <Box sx={{ px: 2, pb: 2 }}>
        <Typography 
          sx={{ 
            fontSize: '0.7rem', 
            color: 'rgba(255,255,255,0.4)',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            mb: 1,
          }}
        >
          {activeView === 'user' ? 'User ID' : 'Room ID'}
        </Typography>
        <TextField
          fullWidth
          size="small"
          placeholder={activeView === 'user' ? 'Enter user ID...' : 'Enter room ID...'}
          value={activeView === 'user' ? userId : roomId}
          onChange={(e) => activeView === 'user' 
            ? onUserIdChange(e.target.value) 
            : onRoomIdChange(e.target.value)
          }
          onKeyPress={handleKeyPress}
          disabled={isLoading}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {/* <SearchIcon sx={{ fontSize: 18, color: 'rgba(255,255,255,0.3)' }} /> */}
                <Iconify
                  icon="ic:baseline-search"
                  width={18}
                  style={{ color: 'rgba(255,255,255,0.3)' }}
                  />

              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              fontSize: '0.85rem',
              background: 'rgba(255, 255, 255, 0.03)',
              borderRadius: '10px',
              color: 'white',
              '& fieldset': {
                borderColor: 'rgba(255, 255, 255, 0.1)',
              },
              '&:hover fieldset': {
                borderColor: 'rgba(255, 255, 255, 0.2)',
              },
              '&.Mui-focused fieldset': {
                borderColor: activeView === 'user' ? '#00f5ff' : '#4d6cff',
              },
            },
            '& .MuiInputBase-input::placeholder': {
              color: 'rgba(255, 255, 255, 0.3)',
              opacity: 1,
            },
          }}
        />
        
        {/* Load Button */}
        <Box
          onClick={onSubmit}
          sx={{
            mt: 1.5,
            py: 1,
            borderRadius: '10px',
            background: activeView === 'user'
              ? 'linear-gradient(135deg, #00f5ff, #b24cff)'
              : 'linear-gradient(135deg, #4d6cff, #ff3cac)',
            cursor: isLoading ? 'wait' : 'pointer',
            opacity: isLoading ? 0.7 : 1,
            transition: 'all 0.3s ease',
            textAlign: 'center',
            '&:hover': {
              opacity: isLoading ? 0.7 : 0.9,
              transform: isLoading ? 'none' : 'translateY(-1px)',
            },
          }}
        >
          <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: 'white' }}>
            {isLoading ? 'Loading...' : 'Load Graph'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ViewSwitcher;

